import { criarFinalizador } from '@/uteis/action/devolver/finalizador'

export const eliminar = (dados, dadosSessao) => {
  var eliminacao = {
    ...dados,
    participante: criarFinalizador(dadosSessao, true)
  }

  return eliminacao
}
